import { useMemo } from "react";
import { useApolloClient } from "@apollo/client";
import { Mutation, Query } from "@models/ISchema";
import { sessionAssignationStore } from "@context/sessionAssignation";
import { useSettingsStore } from "@context/useSettingsStore";
import { isGroupDropDateEnabled } from "@utils/unassignedInstructors";
import assignationSessionsPreviewQuery from "../graphql/assignationSessionsPreview.query.graphql";
import { sessionsCrud } from "../graphql/sessionsCrud.mutation";
import { createSessionAssignationWorkflow } from "../utils/workflow";

export const useSessionAssignationWorkflow = (store = sessionAssignationStore) => {
  const client = useApolloClient();
  return useMemo(
    () =>
      createSessionAssignationWorkflow({
        store,
        preview: async (context, input) => {
          const { scenarioId, originId } = context;
          const { data } = await client.query<Query>({
            query: assignationSessionsPreviewQuery,
            variables: { scenarioId, originId, input },
            fetchPolicy: "no-cache",
          });
          return data?.cube?.assignationSessionsPreview;
        },
        crud: async (context, input) => {
          const { scenarioId, originId } = context;
          const { data } = await client.mutate<Mutation>({
            mutation: sessionsCrud,
            variables: { scenarioId, originId, input },
          });
          return data?.cube?.sessionsCrud;
        },
        reportsUnassignedInstructors: () =>
          isGroupDropDateEnabled(useSettingsStore.getState().instructorLinkTags),
      }),
    [client, store],
  );
};
